var _g, _path, _g2, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 98,
    viewBox: "0 0 97 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_249_666)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_249_666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6635 87.2529C69.813 87.2529 86.9579 70.1079 86.9579 48.9585C86.9579 27.809 69.813 10.6641 48.6635 10.6641C27.5141 10.6641 10.3691 27.809 10.3691 48.9585C10.3691 70.1079 27.5141 87.2529 48.6635 87.2529Z",
    fill: "#606060"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_249_666",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 20,
    width: 59,
    height: 58
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.6176 48.9582C77.6176 32.9672 64.6543 20.0039 48.6633 20.0039C32.6723 20.0039 19.709 32.9672 19.709 48.9582C19.709 64.9492 32.6723 77.9125 48.6633 77.9125C64.6543 77.9125 77.6176 64.9492 77.6176 48.9582Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_249_666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.709 20.0039H77.6176V77.9125H19.709V20.0039Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8899 20.0039H19.709V20.1849H19.8899V20.0039Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3311 58.0059H35.9961V59.8155H61.3311V58.0059ZM61.3311 59.8155H35.9961V61.6251H61.3311V59.8155ZM61.3311 61.6251H35.9961V63.4348H61.3311V61.6251ZM61.3311 63.4348H35.9961V65.2444H61.3311V63.4348ZM39.6154 65.2444H35.9961V67.0541H39.6154V65.2444ZM61.3311 65.2444H41.425V67.0541H61.3311V65.2444ZM39.6154 67.0541H35.9961V68.8637H39.6154V67.0541ZM61.3311 67.0541H41.425V68.8637H61.3311V67.0541ZM39.6154 68.8637H35.9961V70.6734H39.6154V68.8637ZM61.3311 68.8637H41.425V70.6734H61.3311V68.8637ZM39.6154 70.6734H35.9961V72.483H39.6154V70.6734ZM61.3311 70.6734H41.425V72.483H61.3311V70.6734ZM39.6154 72.483H35.9961V74.2927H39.6154V72.483ZM61.3311 72.483H41.425V74.2927H61.3311V72.483ZM39.6154 74.2927H35.9961V76.1023H39.6154V74.2927ZM61.3311 74.2927H41.425V76.1023H61.3311V74.2927ZM39.6154 76.1023H35.9961V77.912H39.6154V76.1023ZM61.3311 76.1023H41.425V77.912H61.3311V76.1023Z",
    fill: "#9F21A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0922 63.4355H52.2825V65.2452H54.0922V63.4355ZM50.4729 65.2452H45.0439V67.0548H50.4729V65.2452Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2823 65.2441H50.4727V67.0538H52.2823V65.2441Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0919 65.2441H52.2822V67.0538H54.0919V65.2441Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9014 65.2441H54.0918V67.0538H55.9014V65.2441Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.044 67.0547H43.2344V68.8643H45.044V67.0547ZM48.6633 67.0547H46.8537V68.8643H48.6633V67.0547Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4727 67.0547H48.6631V68.8643H50.4727V67.0547Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0922 67.0547H50.473V68.8643H54.0922V67.0547ZM45.044 68.8643H43.2344V70.674H45.044V68.8643ZM48.6633 68.8643H46.8537V70.674H48.6633V68.8643Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2824 68.8652H48.6631V70.6749H52.2824V68.8652Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0921 68.8652H52.2824V70.6749H54.0921V68.8652ZM48.6632 70.6749H46.8535V72.4845H48.6632V70.6749ZM54.0921 70.6749H52.2824V72.4845H54.0921V70.6749Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0442 25.4336H43.2345V27.2432H45.0442V25.4336ZM52.2827 25.4336H46.8538V27.2432H52.2827V25.4336ZM54.0924 27.2432H41.4249V29.0529H54.0924V27.2432ZM54.0924 29.0529H39.6152V30.8625H54.0924V29.0529Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.425 30.8613H37.8057V32.671H41.425V30.8613Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0923 30.8613H41.4248V32.671H54.0923V30.8613Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5215 30.8613H54.0925V32.671H59.5215V30.8613ZM46.854 32.671H35.9961V34.4806H46.854V32.671Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0921 32.6719H46.8535V34.4815H54.0921V32.6719Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3311 32.6719H54.0925V34.4815H61.3311V32.6719ZM52.2829 34.4815H35.9961V36.2912H52.2829V34.4815Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0919 34.4805H52.2822V36.2901H54.0919V34.4805Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3312 34.4805H54.0926V36.2901H61.3312V34.4805ZM63.1408 36.2901H34.1865V38.0998H63.1408V36.2901ZM63.1408 38.0998H34.1865V39.9094H63.1408V38.0998ZM63.1408 39.9094H34.1865V41.719H63.1408V39.9094ZM63.1408 41.719H34.1865V43.5287H63.1408V41.719ZM63.1408 43.5287H34.1865V45.3383H63.1408V43.5287ZM63.1408 45.3383H34.1865V47.148H63.1408V45.3383ZM63.1408 47.148H34.1865V48.9576H63.1408V47.148ZM63.1408 48.9576H34.1865V50.7673H63.1408V48.9576ZM48.6637 50.7673H34.1865V52.5769H48.6637V50.7673Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9017 50.7676H48.6631V52.5772H55.9017V50.7676Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1408 50.7676H55.9023V52.5772H63.1408V50.7676ZM48.6637 52.5772H34.1865V54.3869H48.6637V52.5772Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.521 52.5781H48.6631V54.3878H59.521V52.5781Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1408 52.5781H59.5215V54.3878H63.1408V52.5781ZM48.6637 54.3878H34.1865V56.1974H48.6637V54.3878Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9017 54.3867H48.6631V56.1964H55.9017V54.3867Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1408 54.3867H55.9023V56.1964H63.1408V54.3867ZM48.6637 56.1964H34.1865V58.006H48.6637V56.1964Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9017 56.1973H48.6631V58.0069H55.9017V56.1973Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1409 56.1973H55.9023V58.0069H63.1409V56.1973Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6635 39.9102H37.8057V41.7198H48.6635V39.9102ZM61.331 39.9102H50.4732V41.7198H61.331V39.9102ZM39.6153 41.7198H37.8057V43.5294H39.6153V41.7198Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2345 41.7188H39.6152V43.5284H43.2345V41.7188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8537 41.7188H43.2344V43.5284H46.8537V41.7188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6632 41.7188H46.8535V43.5284H48.6632V41.7188ZM52.2824 41.7188H50.4728V43.5284H52.2824V41.7188Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9015 41.7188H52.2822V43.5284H55.9015V41.7188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5216 41.7188H55.9023V43.5284H59.5216V41.7188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3313 41.7188H59.5216V43.5284H61.3313V41.7188ZM39.6155 43.5284H32.377V45.338H39.6155V43.5284Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2345 43.5293H39.6152V45.3389H43.2345V43.5293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8537 43.5293H43.2344V45.3389H46.8537V43.5293Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2824 43.5293H46.8535V45.3389H52.2824V43.5293Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9015 43.5293H52.2822V45.3389H55.9015V43.5293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5216 43.5293H55.9023V45.3389H59.5216V43.5293Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3313 43.5293H59.5216V45.3389H61.3313V43.5293ZM34.1866 45.3389H32.377V47.1486H34.1866V45.3389ZM39.6155 45.3389H37.8059V47.1486H39.6155V45.3389Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2345 45.3398H39.6152V47.1495H43.2345V45.3398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8537 45.3398H43.2344V47.1495H46.8537V45.3398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6632 45.3398H46.8535V47.1495H48.6632V45.3398ZM52.2824 45.3398H50.4728V47.1495H52.2824V45.3398Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9015 45.3398H52.2822V47.1495H55.9015V45.3398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5216 45.3398H55.9023V47.1495H59.5216V45.3398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3313 45.3398H59.5216V47.1495H61.3313V45.3398ZM34.1866 47.1495H32.377V48.9591H34.1866V47.1495ZM39.6155 47.1495H37.8059V48.9591H39.6155V47.1495Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2345 47.1484H39.6152V48.9581H43.2345V47.1484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8537 47.1484H43.2344V48.9581H46.8537V47.1484Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6632 47.1484H46.8535V48.9581H48.6632V47.1484ZM52.2824 47.1484H50.4728V48.9581H52.2824V47.1484Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9015 47.1484H52.2822V48.9581H55.9015V47.1484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5216 47.1484H55.9023V48.9581H59.5216V47.1484Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.331 47.1484H59.5214V48.9581H61.331V47.1484ZM48.6635 48.9581H37.8057V50.7677H48.6635V48.9581ZM61.331 48.9581H50.4732V50.7677H61.331V48.9581Z",
    fill: "#F3322C"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63281 27.369V5.06055H29.7675M71.0795 5.06055H92.5617V26.5428M92.5617 69.5072V90.9895H71.0795M28.115 90.9895H6.63281V69.5072",
    stroke: "#D8BE8D",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_249_666",
    x: 0.369141,
    y: 0.664062,
    width: 96.5889,
    height: 96.5887,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.776471 0 0 0 0 0.231373 0 0 0 0 0.196078 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_249_666"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_249_666",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_249_666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBig);
export default __webpack_public_path__ + "static/media/userBig.5d40b754dfaf9e98b94f5c9d18233d76.svg";
export { ForwardRef as ReactComponent };